import { apiRequest } from '@/utils/api-request';
import { NotificationStatusResponse } from '@/types/notification-types';
import * as Sentry from '@sentry/react';

export async function markAllNotificationsRead(
  orgId: string,
): Promise<NotificationStatusResponse> {
  try {
    const response = await apiRequest<NotificationStatusResponse>({
      url: `/orgs/${orgId}/notifications/read-all`,
      target: 'notifications',
      method: 'POST',
    });

    return response.data ?? { status: 'ok' };
  } catch (error) {
    Sentry.captureException(error, {
      extra: { context: 'mark-all-notifications-read', orgId },
    });
    throw error;
  }
}
